import React from "react";
import { Link } from "react-router-dom";
import PageHelmet from "../component/common/Helmet";
import HeaderAbs from "../component/header/HeaderAbs";
import FooterTwo from "../component/footer/FooterTwo";

const Archive = () => {
    return (
        <React.Fragment>
            <PageHelmet
                pageTitle="Archive"
                description="Earlier projects and research notes (archive). For enterprise AI work, see Enterprise AI and Recent Work."
                canonical="https://www.theomefford.com/archive"
                robots="noindex,follow"
            />

            <HeaderAbs homeLink="/" logo="symbol-dark" color="color-black" />

            <div className="rn-page-title-area pt--120 pb--70 bg_color--1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-single-page-title text-center pt--60">
                                <h2 className="title theme-gradient">Archive</h2>
                                <p className="description">
                                    Earlier work and academic projects. This page is intentionally de-emphasized for search.
                                    {" "}
                                    For enterprise AI platform delivery, see{" "}
                                    <Link to="/enterprise-ai">Enterprise AI</Link>{" "}
                                    and{" "}
                                    <Link to="/recent-work">Recent Work</Link>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rn-blog-details pt--80 pb--120 bg_color--5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="inner-wrapper">
                                <div id="des" className="inner mb--60">
                                    <h3 className="title">Discrete Event Simulation (DES)</h3>
                                    <p>
                                        A discrete event simulation of a teleradiology network, built to explore routing/queueing
                                        behavior and operational efficiency under different workloads.
                                    </p>
                                    <div className="d-flex flex-wrap mt--20" style={{ gap: "12px" }}>
                                        <a
                                            className="rn-button-style--2 btn-solid"
                                            href="https://github.com/temefford/DES"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Code
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="https://colab.research.google.com/drive/1G42XJu26m4uWVqzKP4lPmdGlcnXTQrU-#scrollTo=WTCWsDeImdxS"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Colab
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="https://des-image-yws742o3ja-uc.a.run.app/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Dashboard
                                        </a>
                                    </div>
                                </div>

                                <div id="genomics" className="inner mb--60">
                                    <h3 className="title">Genomics — Cancer Detection (PDF)</h3>
                                    <p>
                                        Applied ML project notes and results for a genomics/cancer detection problem.
                                    </p>
                                    <div className="d-flex flex-wrap mt--20" style={{ gap: "12px" }}>
                                        <a
                                            className="rn-button-style--2 btn-solid"
                                            href="/assets/images/portfolio/GenomicsProject.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Open PDF
                                        </a>
                                    </div>
                                </div>

                                <div id="higgs" className="inner mb--60">
                                    <h3 className="title">Higgs Detection (PDF)</h3>
                                    <p>
                                        Research notes and a machine learning project focused on Higgs Boson detection.
                                    </p>
                                    <div className="d-flex flex-wrap mt--20" style={{ gap: "12px" }}>
                                        <a
                                            className="rn-button-style--2 btn-solid"
                                            href="/assets/images/portfolio/Higgs.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Open PDF
                                        </a>
                                    </div>
                                </div>

                                <div id="stocks" className="inner mb--60">
                                    <h3 className="title">Machine Learning Guided Investing</h3>
                                    <p>
                                        Academic research project exploring ML models for peer-implied valuation and
                                        mispricing-based strategies.
                                    </p>
                                    <div className="d-flex flex-wrap mt--20" style={{ gap: "12px" }}>
                                        <a
                                            className="rn-button-style--2 btn-solid"
                                            href="https://www.github.com/temefford/USF-Finance-Research"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Source Code
                                        </a>
                                    </div>
                                </div>

                                <div id="physics" className="inner">
                                    <h3 className="title">Graduate Physics Papers (PDFs)</h3>
                                    <p>
                                        Selected graduate research notes and papers (PDF downloads + GitHub mirror).
                                    </p>
                                    <div className="d-flex flex-wrap mt--20" style={{ gap: "12px" }}>
                                        <a
                                            className="rn-button-style--2 btn-solid"
                                            href="https://github.com/temefford/Graduate-Physics-Papers"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            GitHub repo
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="/assets/images/blog/QuantumMemoryDCLZ.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Quantum Memory (PDF)
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="/assets/images/blog/QuantumPrincipleComponentAnalysis.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            QPCA (PDF)
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="/assets/images/blog/QuantumPatternRecognitioninApplicationtotheConnectome.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Quantum Pattern Recognition (PDF)
                                        </a>
                                        <a
                                            className="rn-button-style--2 rn-btn-dark"
                                            href="/assets/images/blog/TopologicalQuantumComputation.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Topological QC (PDF)
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterTwo />
        </React.Fragment>
    );
};

export default Archive;
